import { SearchOutlined } from '@ant-design/icons';
import { ReactElement, useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { isBlankArray } from '../../../crm/inPatient/service/crmUtils';
import { RootState } from '../../../../store';
import React from 'react';
import { ReconciliationState } from '../../../../store/models/reconciliationModel';

interface ICustomFilterDropdown {
  filtered?: boolean;
  filterKey: string;
}

const ColumnFilterDropdown = ({filterKey}: ICustomFilterDropdown): ReactElement => {
  const [color, setColor] = useState('#bfbfbf' as any);
  const {columnFilters: filters} = useSelector((state: RootState): ReconciliationState => state.reconciliation || []);
  useEffect((): any => {
    if (Array.isArray(filters.forEach((el: any): any => { if (el.key === filterKey) { return el.value; } else { return null; }}))) {
      setColor((filters[filterKey].length > 0 && !isBlankArray(filters[filterKey])) ? '#3c3ada' : '#bfbfbf');
    } else {
      setColor((filters[filterKey]) ? '#3c3ada' : '#bfbfbf');
    }
  }, [filters]);

  return (
    <React.Fragment>
      <SearchOutlined style={{ color }} />
    </React.Fragment>
  );
};
export default ColumnFilterDropdown;
